export default __webpack_public_path__ + "static/media/class_selected.8a7e42e9.svg";